import { Ref } from 'components/DesignContentPreview/Types'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'

/**
 * Set the camera to the current frame and zoom it into view, taking into
 * account the snap point. This is useful for mobile devices where the frame
 * may be partially off-screen due to a drawer or other UI element.
 *
 * @param editorRef - The ref of a DesignContentPreview instance
 * @param snapPoint - The point on the screen to snap the bottom edge of the frame to (0-1)
 * @returns void
 */
export const zoomFrameIntoView = (editorRef: Ref, snapPoint: number) => {
  const editor = editorRef.getEditor()
  const frame = getCurrentFrame(editor)
  const renderingBounds = editor.getRenderingBounds()
  const viewportScreenBounds = editor.getViewportScreenBounds()
  const bottomY = window.innerHeight * snapPoint
  const reducedHeight = bottomY - viewportScreenBounds.y
  const reductionFactor = reducedHeight / viewportScreenBounds.height
  const frameHeight = (frame && editor.getShapePageBounds(frame)?.height) || 0
  const currentHeight = frameHeight - renderingBounds.y
  const newHeight = currentHeight / reductionFactor
  const difference = newHeight - currentHeight
  const padding = { top: 0, bottom: difference }
  editorRef.setCameraToCurrentFrame({ animate: true, isMobile: true, padding })
}
